import { render } from "./ZabbixEdit.vue?vue&type=template&id=27081e6e"
import script from "./ZabbixEdit.vue?vue&type=script&lang=js"
export * from "./ZabbixEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__